import type * as React from 'react';
import { del } from '@Domain/Api';
import beneficiaryDeleted, {
	type BeneficiaryDeletedAction,
} from '@Application/Beneficiaries/Beneficiaries/Actions/beneficiaryDeleted';
import beneficiaryDeletionFailed, {
	type BeneficiaryDeletionFailedAction,
} from '@Application/Beneficiaries/Beneficiaries/Actions/beneficiaryDeletionFailed';
import type DeleteBeneficiary from '@Application/Beneficiaries/Beneficiaries/Commands/DeleteBeneficiary';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = BeneficiaryDeletedAction | BeneficiaryDeletionFailedAction;

export default (command: DeleteBeneficiary) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			await del<void>(
				`${parameters.api.host}/api/facilities/${command.facilityId}/beneficiaries/${command.beneficiaryId}`,
			);

			const action = beneficiaryDeleted({ beneficiaryId: command.beneficiaryId }, command.facilityId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = beneficiaryDeletionFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
